








import { Component, Vue } from "vue-property-decorator";
import store from "./store";

@Component
export default class App extends Vue {
  get loaded(): boolean {
    return store.state.globalAppDataModule.loaded;
  }
}
